// Temporary compatibility bridge until Portal Server supports resultset stdin
// on plugin actions natively. No customer/query IDs belong in this module.
export const RESULTSET_STDIN_SETUP = 'Übergabe Resultset per stdin'

export function getQueryExportRequest(action, targets, queryParameters, queryID) {
  if (action?.type !== 4) return null
  const setup = String(action.pluginSetupToken || '').split(';')
    .map(token => {
      const position = token.indexOf('=')
      return position < 0 ? null : [token.slice(0, position).trim(), token.slice(position + 1).trim()]
    }).filter(Boolean).filter(([key]) => key === RESULTSET_STDIN_SETUP)
  if (setup.length === 0) return null
  if (setup.length !== 1) throw new Error('Die stdin-Setupoption ist mehrdeutig konfiguriert.')
  const enabled = setup[0][1].toLowerCase()
  if (enabled === 'false' || enabled === '') return null
  if (enabled !== 'true') throw new Error('Die stdin-Setupoption erwartet true oder false.')

  const extension = String(action.pluginParamcontext || '').trim()
  const matches = Array.isArray(targets) ? targets.filter(target => target.extension === extension) : []
  if (!extension || matches.length !== 1) throw new Error('Das Exportziel ist nicht eindeutig in der Sitekonfiguration registriert.')
  const target = matches[0]
  if (target.queryIDs && (!Array.isArray(target.queryIDs) || !target.queryIDs.includes(queryID))) {
    throw new Error('Dieses Exportziel ist für die aktuelle Abfrage nicht freigegeben.')
  }
  if (!Array.isArray(queryParameters)) throw new Error('Die Abfrageparameter fehlen.')
  const parameters = queryParameters.map(parameter => ({...parameter}))
  const nameOf = parameter => parameter.name || parameter.nativename
  const getValue = name => parameters.find(parameter => nameOf(parameter) === name)?.value
  if (target.monthParameter && !/^(?:[1-9]|1[0-2])$/.test(String(getValue(target.monthParameter)))) {
    throw new Error('Für diesen Export muss ein einzelner Monat ausgewählt sein.')
  }
  if (target.yearParameter && !/^\d{4}$/.test(String(getValue(target.yearParameter)))) {
    throw new Error('Für diesen Export muss ein gültiges Jahr ausgewählt sein.')
  }
  const overrides = target.parameterOverrides || {}
  if (typeof overrides !== 'object' || Array.isArray(overrides)) throw new Error('Ungültige Export-Parameterkonfiguration.')
  for (const [name, value] of Object.entries(overrides)) {
    const matching = parameters.filter(parameter => nameOf(parameter) === name)
    if (matching.length !== 1 || typeof value !== 'string') throw new Error('Exportparameter können nicht eindeutig übernommen werden.')
    matching[0].value = value
  }
  return {extension, queryParameter: parameters}
}
